<template>
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col-lg-3 lbl">
                    <label>Site d'origine:</label>
                </div>
                <div class="col-lg-9">
                    <Dropdown
                            class="input-width-100"
                            v-model="siteOrigine"
                            :options="sitesOrigineLibelles"
                            optionValue="valeur"
                            optionLabel="texte"
                            @:keyup.enter="imprimer"
                            scrollHeight="205px"
                            :showClear="true"
                    />
                </div>
            </div>
        </div>
        <div class="col"></div>
    </div>
    <div class="row">
        <div class="col">
            <div class="row">
                <div class="col-lg-3 lbl">
                    <label>Nature:</label>
                </div>
                <div class="col-lg-9">
                    <Dropdown
                            class="input-width-100"
                            v-model="nature"
                            :options="naturesLibelles"
                            optionValue="valeur"
                            optionLabel="texte"
                            @:keyup.enter="imprimer"
                            scrollHeight="205px"
                            :showClear="true"
                    />
                </div>
            </div>
        </div>
        <div class="col"></div>
    </div>
</template>

<script>
export default {
    name: "CritereRechercheDiversReconnaissancePlaques",
    emits: ['imprimer'],
    data() {
        return {
            siteOrigine: null,
            sitesOrigineLibelles: [],
            nature: null,
            naturesLibelles: [],
            criteresRecherche:{}
        };
    },
    methods: {
        assignerListeSiteOrigine(res) {
            this.sitesOrigineLibelles = res;
        },
        assignerListeNature(res) {
            this.naturesLibelles = res;
        },
        getCriteresRecherche(){
            this.criteresRecherche.nature = this.intervenant;
            this.criteresRecherche.siteOrigine = this.siteOrigine;

            return this.criteresRecherche;
        }
    },
}
</script>